<template>
  <div class="main">
    <report-top> </report-top>
    <selectTool ref="selectTool">
      <template slot="text">夜间行车规则列表</template>
      <template slot="btn"
        ><Button @click="getList" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openBlind(row)"> 绑定 </Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      width="700"
      ref="formModel"
      :title="isAdd ? '新增规则' : '编辑规则'"
    >

      <Alert show-icon slot="days" type="warning">
        规则触发周期，全选或全不选均表示全周期
      </Alert>
      <Row slot="times">
        <Col span="24" v-for="(x, index) in item.timeList" :key="index"
          ><FormItem :label="'第' + (index + 1) + '区间'">
            <TimePicker
              format="HH:mm"
              type="timerange"
              placement="bottom-end"
              placeholder="Select time"
              :clearable="false"
              v-model="item.timeList[index]" /></FormItem></Col
        ><Alert show-icon type="warning">
          跨天区间需以0点为界线，分两个（及以上）区间录入
        </Alert>
        <Col span="24"
          ><Button size="small" type="success" @click="zengjia">增加区间</Button
          ><Button size="small" @click="jianshao">减少区间</Button></Col
        >
      </Row>
      <Button slot="btn" type="primary" @click="addUpdate">确认修改</Button>
    </form-model>
    <blind ref="blind" v-model="deviceList" @blind="blind"></blind>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },

        {
          title: "创建者账号",
          key: "createAccount",
          sort: 10,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          sort: 11,
        },
        {
          title: "操作",
          slot: "action",
          width: 160,
          align: "center",
          fixed: "right",
          sort: 12,
        },
      ],
      tableData: [],
      item: {
        name: "",
        remark: "",
        duration: 30,
        timeList: [
          ["22:00", "23:59"],
          ["00:00", "04:59"],
        ],
        weekList: [],
        enabled: true,
        groupId:'',
        groupName:''
      },

      total: 0,
      deviceList: [],
      forms: [
        {
          title: "规则名称",
          key: "name",
          type: "Input",
          required: true,
          span:12
        },
        {
          title: "单位名称",
          key: "groupId",
          key1: "groupName",
          type: "selectGroup",
        },
        {
          title: "容许时长/秒",
          key: "duration",
          type: "InputNumber",
          span:6
        },
        {
          title: "是否启用",
          key: "enabled",
          type: "bool",
          noTable: true,
          span:6
        },
        {
          title: "周期",
          key: "weekList",
          type: "checkbox",
          selectType: "obj",
          selectItems: [
            { id: 0, name: "周日" },
            { id: 1, name: "周一" },
            { id: 2, name: "周二" },
            { id: 3, name: "周三" },
            { id: 4, name: "周四" },
            { id: 5, name: "周五" },
            { id: 6, name: "周六" },
          ],
          span: 24,
          noTable: true,
          slotForm:'days'
        },
        {
          title: "时间段",
          slotForm: "times",
          span: 24,
          noTable: true,
        },

        {
          title: "备注",
          key: "remark",
          type: "Input",
          span: 24,
        },
      ],
      searchItem: {
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [],

    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.rule + "/night/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
        console.log(data);
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      console.log(this.item);
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.rule + "/night/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.rule + "/night/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.rule + "/night/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
      this.getItem(row, 1);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },

    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    getItem(row, type) {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.rule + "/night/item",
        data: { id: row.id },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          if (type == 1) {
            var data = res.data.data.fenceRuleList;
            var arr = [];
            for (let i = 0; i < data.length; i++) {
              arr.push(data[i].id);
            }
            this.item.fenceRuleIdList = arr;
            this.openForm = true;
          } else {
            console.log(res.data.data);
            var d = res.data.data.deviceList;
            this.deviceList = [];
            for (let i = 0; i < d.length; i++) {
              var obj = {
                id: d[i].deviceId,
                name: d[i].bindAttr,
                key: d[i].deviceId,
                useType: d[i].useType,
              };
              this.deviceList.push(obj);
            }
            this.$refs.blind.open(row);
          }
        }
      });
    },
    openBlind(row) {
      this.getItem(row);
      this.blindId = row.id;
    },
    blind(data) {
      this.utils.loading(this, "处理中");
      var deviceIdList = [];
      for (let i = 0; i < data.length; i++) {
        deviceIdList.push(data[i].id);
      }
      this.axios({
        method: "post",
        url: this.axios.rule + "/night/bind",
        data: { deviceIdList: deviceIdList, id: this.blindId },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
      });
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    zengjia() {
      this.item.timeList.push(["02:00", "05:59"]);
    },
    jianshao() {
      this.item.timeList.splice(this.item.timeList.length - 1, 1);
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/rule/ruleMidNight.vue